import React, { useState } from 'react';
import { DropDownArrow } from '@yme/assets/icons';
import { useOutsideClick } from '@yme/hooks/index';
import { EVENT_NAME_MAP } from '@yme/utils/constants';
import { MAX_COUNT_VISIBLE_ITEMS } from './constants';
import { DropDownActiveElementStyled, DropDownItemStyled, DropDownListStyled, DropDownListWrapperStyled, DropDownStyled, SVGIconStyled, } from './styled';
// TODO: (D.K.) Should re-use general drop-down
export function DropDown(props) {
    const { tabData, activeTab, onSetActiveTab, isRightToLeft = false } = props;
    const [isDropDownExpanded, setIsDropDownExpanded] = useState(false);
    const { elementRef } = useOutsideClick({
        eventName: EVENT_NAME_MAP.click,
        callback: () => setIsDropDownExpanded(false),
    });
    const onClickHandler = (id) => {
        onSetActiveTab(id);
        setIsDropDownExpanded(false);
    };
    const onClickDropDownHandler = () => {
        setIsDropDownExpanded(!isDropDownExpanded);
    };
    return (React.createElement(DropDownStyled, { ref: elementRef },
        React.createElement(DropDownActiveElementStyled, { onClick: onClickDropDownHandler },
            activeTab.tabTitle,
            " ",
            activeTab.amountLabel && ` (${activeTab.amountLabel})`,
            React.createElement(SVGIconStyled, { type: DropDownArrow, isDropDownExpanded: isDropDownExpanded })),
        React.createElement(DropDownListWrapperStyled, { isDropDownExpanded: isDropDownExpanded },
            React.createElement(DropDownListStyled, { withScroll: tabData.length >= MAX_COUNT_VISIBLE_ITEMS, isRightToLeft: isRightToLeft }, tabData.map(({ entityId, tabTitle, amountLabel }) => (React.createElement(DropDownItemStyled, { key: entityId, onClick: () => onClickHandler(entityId), isActiveTab: activeTab.entityId === entityId },
                tabTitle,
                " ",
                amountLabel && ` (${amountLabel})`)))))));
}
DropDown.displayName = 'TabsComponent_DropDown_MobileView';
